import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const PauseSolidIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('PauseSolidIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path d="M4 4a.667.667 0 0 1 .667-.667H6A.667.667 0 0 1 6.667 4v8a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12zM9.334 4A.667.667 0 0 1 10 3.333h1.334A.667.667 0 0 1 12 4v8a.667.667 0 0 1-.666.666H10A.667.667 0 0 1 9.334 12z" />
  </svg>
);
PauseSolidIcon.id = 'PauseSolidIcon';
PauseSolidIcon.displayName = 'PauseSolidIcon';
export default PauseSolidIcon;
